import { ValueOf } from "src/types.d"

export const ContactSurveyAnswerScreens = Object.freeze({
  ContactSurveyAnswerOverview: "ContactSurveyAnswerOverview",
  ContactSurveyAnswerDetail: "ContactSurveyAnswerDetail",
} as const)

export type ContactSurveyAnswerScreens = ValueOf<typeof ContactSurveyAnswerScreens>
